/**
 * Created by tatekim on 2017. 2. 2..
 */
(function() {
    'use strict';
    var app = angular.module('admin');

    var lazyLoader = function(modules) {
        return {
            loadModules: ['$ocLazyLoad', '$q', function($ocLazyLoad, $q) {
                return $ocLazyLoad.load(modules).then(function() {
                    console.log('loaded: ', modules);
                }, function(error) {
                    console.log('load failed: ', modules, error);
                    return $q.reject(error);
                });
            }],
        };
    };

    app.config(function($routeProvider, $locationProvider, vv, PERMISSIONS) {
        if (vv.getVvMetaData('version') == '2') {
            $routeProvider.when('/', {
                templateUrl: '/admin/home.html?_hv=4bed9ed',
                resolve: lazyLoader('admin.quiz.go.edit'),
                title: ''
            });
            $routeProvider.when('/mypage', {
                templateUrl: '/admin/mypage.html?_hv=29376b0',
                controller: 'MyPageController',
                resolve: lazyLoader([
                    'admin.models', 'admin.user.mypage'
                ]),
                permissions: [PERMISSIONS.LOGIN],
                title: function(gettextCatalog) {
                    return gettextCatalog.getString('My Page');
                }
            });
            $routeProvider.when('/app_notifier', {
                templateUrl: '/admin/app_notifier.html?_hv=b456f5b',
                controller: 'AppNotifierController',
                resolve: lazyLoader('admin.app.notifier'),
                title: function(gettextCatalog) {
                    return gettextCatalog.getString('Push Notification');
                }
            });
            $routeProvider.when('/quiz/list', {
                templateUrl: '/admin/quiz_list.html?_hv=505b0c7',
                controller: 'QuizListController',
                reloadOnSearch: false,
                resolve: lazyLoader('admin.quiz'),
                title: function(gettextCatalog) {
                    return gettextCatalog.getString('Quiz List');
                }
            });
            $routeProvider.when('/quiz/create/:quiz_type_name', {
                templateUrl: '/admin/admin_landing.html?_hv=04f094c',
                controller: 'QuizEditController',
                reloadOnSearch: false,
                resolve: lazyLoader('admin.quiz'),
                scopeParams: {
                    mode: 'new'
                },
                title: function(gettextCatalog) {
                    return gettextCatalog.getString('Edit Quiz');
                }
            });
            $routeProvider.when('/quiz/import', {
                templateUrl: '/admin/import_quiz.html?_hv=ad7bf72',
                controller: 'ImportQuizController',
                reloadOnSearch: false,
                resolve: lazyLoader('admin.quiz'),
                title: function(gettextCatalog) {
                    return gettextCatalog.getString('Import Quiz');
                }
            });
            $routeProvider.when('/search/result', {
                templateUrl: '/admin/search_result.html?_hv=3fe23fe',
                controller: 'SearchResultController',
                reloadOnSearch: false,
                resolve: lazyLoader('admin.search'),
                title: function(gettextCatalog) {
                    return gettextCatalog.getString('Search Quiz Result');
                }
            });
            $routeProvider.when('/quiz/competitors', {
                templateUrl: '/admin/competitors_quiz.html?_hv=db883f0',
                controller: 'QuizCompetitorsController',
                reloadOnSearch: false,
                resolve: lazyLoader('admin.search'),
                title: function(gettextCatalog) {
                    return gettextCatalog.getString('Competitors Quiz');
                }
            });
            $routeProvider.when('/privacy_info', {
                templateUrl: '/admin/privacy_info.html?_hv=f2cc215',
                controller: 'PrivacyInfoController',
                reloadOnSearch: false,
                resolve: lazyLoader(['admin.privacy_info']),
                title: function() {
                    return 'Privacy Info';
                }
            });
            $routeProvider.when('/quiz/export', {
                controller: 'QuizExportController',
                templateUrl: '/admin/quiz/quiz_export.html?_hv=b38a545',
                reloadOnSearch: false,
                resolve: lazyLoader(['admin.util', 'admin.quiz.util', 'admin.quiz.stats', 'admin.models', 'admin.quiz.export']),
                title: function(gettextCatalog) {
                    return gettextCatalog.getString('Export Quiz');
                }
            });
            $routeProvider.when('/tr-test', {
                templateUrl: '/admin/translate_test.html?_hv=34eda87',
                controller: 'TranslateTestController',
                reloadOnSearch: false,
                permissions: [PERMISSIONS.TRANSLATE, PERMISSIONS.VIEW],
                resolve: lazyLoader(['admin.quiz.util', 'admin.translate.test']),
                title: function(gettextCatalog) {
                    return gettextCatalog.getString('Translation Test');
                }
            });
            $routeProvider.when('/quiz/tr', {
                templateUrl: '/admin/quiz/quiz_translate_list.html?_hv=da21980',
                controller: 'QuizTranslateReviewListController',
                reloadOnSearch: false,
                permissions: [PERMISSIONS.TRANSLATE, PERMISSIONS.VIEW],
                resolve: lazyLoader(['admin.quiz.util', 'admin.quiz.translate.review.list']),
                title: function(gettextCatalog) {
                    return gettextCatalog.getString('Quiz Translation Review Requests');
                }
            });
            $routeProvider.when('/quiz/tr/:quizId', {
                templateUrl: '/admin/quiz/quiz_translate.html?_hv=9c93888',
                controller: 'QuizTranslateController',
                reloadOnSearch: false,
                permissions: [PERMISSIONS.TRANSLATE, PERMISSIONS.VIEW],
                resolve: lazyLoader('admin.quiz.translate'),
                title: function(gettextCatalog) {
                    return gettextCatalog.getString('Translate Quiz');
                }
            });
            $routeProvider.when('/quiz/inspect/:quizId', {
                templateUrl: '/admin/quiz/quiz_inspect.html?_hv=685c82e',
                controller: 'QuizInspectController',
                reloadOnSearch: false,
                permissions: [PERMISSIONS.TRANSLATE, PERMISSIONS.VIEW],
                resolve: lazyLoader([
                    'admin.models',
                    'admin.quiz.image_previewer',
                    'admin.quiz.inspect']),
                title: function() {
                    return 'Inspect Quiz';
                }
            });

            $routeProvider.when('/quiz/:quiz_id', {
                templateUrl: '/admin/admin_landing.html?_hv=04f094c',
                controller: 'QuizEditController',
                reloadOnSearch: false,
                resolve: lazyLoader('admin.quiz'),
                scopeParams: {
                    mode: 'edit'
                },
                title: function(gettextCatalog) {
                    return gettextCatalog.getString('Edit Quiz');
                }
            });
            $routeProvider.when('/banner/list/:slot', {
                templateUrl: '/admin/banner_list.html?_hv=a25f191',
                controller: 'BannerListController',
                reloadOnSearch: true,
                resolve: lazyLoader('admin.quiz'),
                title: function() {
                    return 'Admin Banners';
                }
            });
            $routeProvider.when('/trend/:model/:itemId?/:what', {
                controller: 'TrendController',
                templateUrl: '/admin/trend/trend.html?_hv=5989bac',
                reloadOnSearch: false,
                resolve: lazyLoader('admin.trend'),
                isFluid: true
            });
            $routeProvider.when('/past/trend/:model/:itemId?/:what', {
                controller: 'TrendController',
                templateUrl: '/admin/trend/trend_past.html?_hv=08a3880',
                reloadOnSearch: false,
                trendType: 'past',
                resolve: lazyLoader('admin.trend'),
                isFluid: true
            });
            $routeProvider.when('/query_profile', {
                controller: 'QueryProfileController',
                templateUrl: '/admin/trend/query_profile.html?_hv=05b3629',
                reloadOnSearch: false,
                resolve: lazyLoader('admin.trend'),
                title: 'Query Profiler',
                isFluid: true
            });
            $routeProvider.when('/search', {
                templateUrl: '/admin/dev/search_quiz.html?_hv=a5b864b',
                controller: 'QuizSearchController',
                resolve: lazyLoader('admin.quiz.search'),
                title: 'Quiz Search'
            });
            $routeProvider.when('/partner/list', {
                templateUrl: '/admin/partnerList.html?_hv=27bffbd',
                controller: 'PartnerListController',
                resolve: lazyLoader('admin.quiz'),
                title: function(gettextCatalog) {
                    return gettextCatalog.getString('파트너 리스트페이지 퀴즈 우선순위 관리');
                }
            });
            $routeProvider.when('/admin-user/list', {
                templateUrl: '/admin/admin_user/manage.html?_hv=f109164',
                controller: 'ManageAdminUserController',
                reloadOnSearch: true,
                resolve: lazyLoader('admin.user.manage'),
                title: function() {
                    return 'Manage Admin Users';
                }
            });
            $routeProvider.when('/admin-user/approve', {
                templateUrl: '/admin/admin_user/approve.html?_hv=a654e80',
                controller: 'ApproveAdminUserController',
                reloadOnSearch: true,
                resolve: lazyLoader('admin.user.approve'),
                title: 'Approve Admin Users',
            });
            $routeProvider.when('/admin-user/secret', {
                templateUrl: '/admin/admin_user/secret.html?_hv=23c42a8',
                controller: 'AdminSecretController',
                reloadOnSearch: true,
                resolve: lazyLoader('admin.user.secret'),
                title: 'Manage Admin Users',
            });
            $routeProvider.when('/cp/:partner/list', {
                templateUrl: '/admin/cpList.html?_hv=42055df',
                controller: 'CpListController',
                resolve: lazyLoader('admin.quiz'),
                title: function(gettextCatalog) {
                    return gettextCatalog.getString('레진코믹스 웹툰 리스트')
                }
            });
            $routeProvider.when('/push_schedule', {
                templateUrl: '/admin/push_schedule.html?_hv=de6b684',
                controller: 'PushScheduleController',
                resolve: lazyLoader('admin.push_schedule'),
                title: 'Push Schedule'
            });
            $routeProvider.otherwise({
                redirectTo: '/'
            });
            $locationProvider.html5Mode(true);
        } else {
            $locationProvider.html5Mode(false);
        }
        $locationProvider.hashPrefix('!');
    });

    app.run(function($rootScope, $window, $injector, $interpolate, gettextCatalog, vv) {
        $rootScope.$on('$routeChangeSuccess', function(event, currentRoute) {
            if (currentRoute.title != null) {
                var titleExp;
                if (angular.isFunction(currentRoute.title))
                    titleExp = $injector.invoke(currentRoute.title);
                else
                    titleExp = currentRoute.title;

                var title = $interpolate(titleExp)(currentRoute.params);

                var envSn = vv.getEnvSn();
                envSn = (envSn === 'la') ? 'es' : envSn;

                if (title)
                    $window.document.title = envSn + ':' + title + ' - ' + gettextCatalog.getString('Vonvon Admin')
                else
                    $window.document.title = envSn + ':' + gettextCatalog.getString('Vonvon Admin')
            }
            var containerBody = vv.$("#containerBody");
            if (currentRoute.isFluid) {
                containerBody.removeClass('container');
                containerBody.addClass('container-fluid');
            } else {
                containerBody.removeClass('container-fluid');
                containerBody.addClass('container');
            }
        });
    });

    app.run(function($rootScope, $window, vvAdminAuth, PERMISSIONS, HOME_PATHS) {
        $rootScope.$on('$routeChangeStart', function (event, next, prev) {
            if (!next.resolve || !next.resolve.permissions) {
                next.resolve = next.resolve || {};
                next.resolve.permissions = [
                    '$q', '$location', 'vvAdminAuth', 'PERMISSIONS', 'HOME_PATHS',
                    function($q, $location, vvAdminAuth, PERMISSIONS, HOME_PATHS) {
                        return vvAdminAuth.initAuth().then(function() {
                          if ($rootScope.user && $rootScope.user['id'] !=  1713) {
                            if ($rootScope.stage === 'real' && (!$rootScope.user['2fa_activated'] || $rootScope.user['2fa_activated'] !== 'Y')) {
                              $location.path('/mypage');
                            }
                          }
                          var allowedPermissions = next.permissions || [PERMISSIONS.VIEW];
                          if (!allowedPermissions.some(function (perm) { return !!$rootScope.PERMITTED[perm]; })) {
                            console.log('No Permission', $rootScope.PERMITTED);
                            if ($rootScope.user) {
                              $location.path(HOME_PATHS[$rootScope.user.admin_type] || '/');
                            }
                            else
                              $window.location.reload();
                            return $q.reject('No Permission');
                          }
                        });
                    }
                ];
            }
        });
    });
})();
